export const Currencies = [
    {
        code: 'USD',
        symbol: '$',
    },
    {
        code: 'CAD',
        symbol: 'CA$',
    },
    {
        code: 'EUR',
        symbol: '€',
    },
    {
        code: 'AED',
        symbol: 'AED',
    },
    {
        code: 'AFN',
        symbol: 'Af',
    },
    {
        code: 'ALL',
        symbol: 'ALL',
    },
    {
        code: 'AMD',
        symbol: 'AMD',
    },
    {
        code: 'ARS',
        symbol: 'AR$',
    },
    {
        code: 'AUD',
        symbol: 'AU$',
    },
    {
        code: 'AZN',
        symbol: 'man.',
    },
    {
        code: 'BAM',
        symbol: 'KM',
    },
    {
        code: 'BDT',
        symbol: 'Tk',
    },
    {
        code: 'BGN',
        symbol: 'BGN',
    },
    {
        code: 'BHD',
        symbol: 'BD',
    },
    {
        code: 'BIF',
        symbol: 'FBu',
    },
    {
        code: 'BND',
        symbol: 'BN$',
    },
    {
        code: 'BOB',
        symbol: 'Bs',
    },
    {
        code: 'BRL',
        symbol: 'R$',
    },
    {
        code: 'BWP',
        symbol: 'BWP',
    },
    {
        code: 'BYR',
        symbol: 'BYR',
    },
    {
        code: 'BZD',
        symbol: 'BZ$',
    },
    {
        code: 'CDF',
        symbol: 'CDF',
    },
    {
        code: 'CHF',
        symbol: 'CHF',
    },
    {
        code: 'CLP',
        symbol: 'CL$',
    },
    {
        code: 'CNY',
        symbol: 'CN¥',
    },
    {
        code: 'COP',
        symbol: 'CO$',
    },
    {
        code: 'CRC',
        symbol: '₡',
    },
    {
        code: 'CVE',
        symbol: 'CV$',
    },
    {
        code: 'CZK',
        symbol: 'Kč',
    },
    {
        code: 'DJF',
        symbol: 'Fdj',
    },
    {
        code: 'DKK',
        symbol: 'Dkr',
    },
    {
        code: 'DOP',
        symbol: 'RD$',
    },
    {
        code: 'DZD',
        symbol: 'DA',
    },
    {
        code: 'EEK',
        symbol: 'Ekr',
    },
    {
        code: 'EGP',
        symbol: 'EGP',
    },
    {
        code: 'ERN',
        symbol: 'Nfk',
    },
    {
        code: 'ETB',
        symbol: 'Br',
    },
    {
        code: 'GBP',
        symbol: '£',
    },
    {
        code: 'GEL',
        symbol: 'GEL',
    },
    {
        code: 'GHS',
        symbol: 'GH₵',
    },
    {
        code: 'GNF',
        symbol: 'FG',
    },
    {
        code: 'GTQ',
        symbol: 'GTQ',
    },
    {
        code: 'HKD',
        symbol: 'HK$',
    },
    {
        code: 'HNL',
        symbol: 'HNL',
    },
    {
        code: 'HRK',
        symbol: 'kn',
    },
    {
        code: 'HUF',
        symbol: 'Ft',
    },
    {
        code: 'IDR',
        symbol: 'Rp',
    },
    {
        code: 'ILS',
        symbol: '₪',
    },
    {
        code: 'INR',
        symbol: 'Rs',
    },
    {
        code: 'IQD',
        symbol: 'IQD',
    },
    {
        code: 'IRR',
        symbol: 'IRR',
    },
    {
        code: 'ISK',
        symbol: 'Ikr',
    },
    {
        code: 'JMD',
        symbol: 'J$',
    },
    {
        code: 'JOD',
        symbol: 'JD',
    },
    {
        code: 'JPY',
        symbol: '¥',
    },
    {
        code: 'KES',
        symbol: 'Ksh',
    },
    {
        code: 'KHR',
        symbol: 'KHR',
    },
    {
        code: 'KMF',
        symbol: 'CF',
    },
    {
        code: 'KRW',
        symbol: '₩',
    },
    {
        code: 'KWD',
        symbol: 'KD',
    },
    {
        code: 'KZT',
        symbol: 'KZT',
    },
    {
        code: 'LBP',
        symbol: 'LB£',
    },
    {
        code: 'LKR',
        symbol: 'SLRs',
    },
    {
        code: 'LTL',
        symbol: 'Lt',
    },
    {
        code: 'LVL',
        symbol: 'Ls',
    },
    {
        code: 'LYD',
        symbol: 'LD',
    },
    {
        code: 'MAD',
        symbol: 'MAD',
    },
    {
        code: 'MDL',
        symbol: 'MDL',
    },
    {
        code: 'MGA',
        symbol: 'MGA',
    },
    {
        code: 'MKD',
        symbol: 'MKD',
    },
    {
        code: 'MMK',
        symbol: 'MMK',
    },
    {
        code: 'MOP',
        symbol: 'MOP$',
    },
    {
        code: 'MUR',
        symbol: 'MURs',
    },
    {
        code: 'MXN',
        symbol: 'MX$',
    },
    {
        code: 'MYR',
        symbol: 'RM',
    },
    {
        code: 'MZN',
        symbol: 'MTn',
    },
    {
        code: 'NAD',
        symbol: 'N$',
    },
    {
        code: 'NGN',
        symbol: '₦',
    },
    {
        code: 'NIO',
        symbol: 'C$',
    },
    {
        code: 'NOK',
        symbol: 'Nkr',
    },
    {
        code: 'NPR',
        symbol: 'NPRs',
    },
    {
        code: 'NZD',
        symbol: 'NZ$',
    },
    {
        code: 'OMR',
        symbol: 'OMR',
    },
    {
        code: 'PAB',
        symbol: 'B/.',
    },
    {
        code: 'PEN',
        symbol: 'S/.',
    },
    {
        code: 'PHP',
        symbol: '₱',
    },
    {
        code: 'PKR',
        symbol: 'PKRs',
    },
    {
        code: 'PLN',
        symbol: 'zł',
    },
    {
        code: 'PYG',
        symbol: '₲',
    },
    {
        code: 'QAR',
        symbol: 'QR',
    },
    {
        code: 'RON',
        symbol: 'RON',
    },
    {
        code: 'RSD',
        symbol: 'din.',
    },
    {
        code: 'RUB',
        symbol: 'RUB',
    },
    {
        code: 'RWF',
        symbol: 'RWF',
    },
    {
        code: 'SAR',
        symbol: 'SR',
    },
    {
        code: 'SDG',
        symbol: 'SDG',
    },
    {
        code: 'SEK',
        symbol: 'Skr',
    },
    {
        code: 'SGD',
        symbol: 'S$',
    },
    {
        code: 'SOS',
        symbol: 'Ssh',
    },
    {
        code: 'SYP',
        symbol: 'SY£',
    },
    {
        code: 'THB',
        symbol: '฿',
    },
    {
        code: 'TND',
        symbol: 'DT',
    },
    {
        code: 'TOP',
        symbol: 'T$',
    },
    {
        code: 'TRY',
        symbol: 'TL',
    },
    {
        code: 'TTD',
        symbol: 'TT$',
    },
    {
        code: 'TWD',
        symbol: 'NT$',
    },
    {
        code: 'TZS',
        symbol: 'TSh',
    },
    {
        code: 'UAH',
        symbol: '₴',
    },
    {
        code: 'UGX',
        symbol: 'USh',
    },
    {
        code: 'UYU',
        symbol: '$U',
    },
    {
        code: 'UZS',
        symbol: 'UZS',
    },
    {
        code: 'VEF',
        symbol: 'Bs.F.',
    },
    {
        code: 'VND',
        symbol: '₫',
    },
    {
        code: 'XAF',
        symbol: 'FCFA',
    },
    {
        code: 'XOF',
        symbol: 'CFA',
    },
    {
        code: 'YER',
        symbol: 'YR',
    },
    {
        code: 'ZAR',
        symbol: 'R',
    },
    {
        code: 'ZMK',
        symbol: 'ZK',
    },
];
